// src/app/equipment-edit/equipment-edit.component.ts
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Equipment } from '../objects/Equipment';
import { Manufacturer } from "../objects/Manufacturer";
import { EquipmentService } from '../Services/equipment.services'
import { ManufacturerService } from '../Services/manufacture.service';

@Component({
  selector: 'app-equipment-edit',
  templateUrl: './equipment-edit.component.html',
  styleUrls: ['./equipment-edit.component.css'],
})
export class EquipmentEditComponent implements OnInit {
  manufature: Manufacturer = {
    id: 0,
    name: '',
    country: ''
  }

  equipment: Equipment = {
    id: 0,
    name: '',
    description: '',
    quantity: 0,
    manufacturer: this.manufature,
    imageUrl: '',
    dailyRate: 0,
  };

  manufacturers: Manufacturer[] = [];
  isSaving = false;
  imageError: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private equipmentService: EquipmentService,
    private manufacturerService: ManufacturerService
  ) {}

  ngOnInit() {
    this.manufacturerService.getManufacturers().subscribe(list => this.manufacturers = list);

    this.route.paramMap.subscribe((params) => {
      const equipmentId = parseInt(params.get('id') || '0', 10);
      if (equipmentId > 0) {
        this.loadEquipment(equipmentId);
      }
    });
  }

  loadEquipment(equipmentId: number) {
    this.equipmentService.getEquipmentById(equipmentId).subscribe((equipment) => {
      this.equipment = { ...equipment, manufacturer: equipment.manufacturer || this.manufature };
    });
  }

  onManufacturerChange(manufacturerId: string) {
    const id = +manufacturerId;
    this.equipment.manufacturer = this.manufacturers.find(m => m.id === id) || this.manufature;
  }

  onImageSelected(event: Event) {
    this.imageError = null;
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      this.imageError = 'Please choose an image file.';
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      this.imageError = 'Image must be smaller than 2MB.';
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      this.equipment.imageUrl = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  }

  removeImage() {
    this.equipment.imageUrl = '';
  }

  saveEquipment() {
    this.isSaving = true;
    this.equipment.dailyRate = +(this.equipment.dailyRate || 0);
    this.equipment.quantity = +(this.equipment.quantity || 0);
    this.equipmentService.editEquipment(this.equipment).subscribe({
      next: () => {
        this.isSaving = false;
        this.router.navigate(['/equipment']);
      },
      error: () => { this.isSaving = false; }
    });
  }

  cancel() {
    this.router.navigate(['/equipment']);
  }
}
